import React from "react";
import ByzTitleBox from "../component/title-box";
import { Card, Grid } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { ByzMuiDatePicker } from "src/components/core-components/mui/inputs/ByzMuiDatePicker";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
//MPOGLU;453141;09042025
function PageTwo() {
  const { t } = useTranslate();
  return (
    <Card sx={{ marginBottom: "5px" }}>
      <ByzTitleBox title={t("blood-transfusion.transfusion-plan")} />
      <Grid
        item
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap" }}
        p={2}
      >
        <Grid item sm={6} xs={12} md={3} lg={2} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.transfusion-start-time")}
          >
            <ByzMuiDatePicker label="" />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={3} lg={2} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.transfusion-speed-duration")}
          >
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <ByzTitleBox title={t("blood-transfusion.transfusion-monitoring")} />

      <Grid
        item
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item md={3} lg={3}>
          <ByzTitleAndInputBox title={""}>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.transfusion-start")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.15-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.45-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.1-hour-15-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.1-hour-45-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.2-hours-15-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ marginBottom: "8px", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.2-hours-45-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ marginBottom: "8px", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.3-hours-15-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ marginBottom: "8px", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.3-hours-45-minutes")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ marginBottom: "8px", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.transfusion-end")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ marginBottom: "8px", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.1-hour-after-transfusion")}
            </ByzMuiTypography>
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.body-temperature")}>
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.blood-pressure")}>
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.pulse")}>
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.respiration")}>
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.other")}>
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={2} xs={12} md={2} lg={2} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.intervention-if-any")}
          >
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <ByzTitleBox title={t("blood-transfusion.transfusion-monitoring")} />

      <Grid
        item
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={6} xs={12} md={3} lg={3} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.transfusion-end-time")}
          >
            <ByzMuiDatePicker
              sx={{
                maxwidth: "300px",
                minWidth: "50px",
                marginLeft: "8px",
              }}
              label=""
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={2} lg={2} xl={2}>
          <ByzTitleAndInputBox title={t("blood-transfusion.transfusion")}>
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout={"row"}
              border="none"
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={2} lg={2} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.undesirable-event-reaction")}
          >
            <ByzMuiRadioButton
              typographyText="blood-transfusion.completed,blood-transfusion.not-completed"
              layout={"row"}
              border="none"
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={3} lg={3} xl={3}></Grid>

        <Grid item sm={6} xs={12} md={3} lg={3} xl={3} ml={1}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.transfused-component-amount")}
          >
            <ByzMuiTextField
              color="primary"
              variant="outlined"
              label=""
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Card>
  );
}

export default PageTwo;
